import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import img from "../assets/Images/patrick-tomasso-Oaqk7qqNh_c-unsplash.jpg"
import LogoComponent from '../subComponents/LogoComponent'
import SocialIcons from '../subComponents/SocialIcons'
import PowerButton from '../subComponents/PowerButton'

import { Blogs } from '../data/BlogData'
import BlogComponent from './BlogComponent'
import AnchorComponent from '../subComponents/Anchor'
import BigTitle from "../subComponents/BigTitlte"
import { motion } from 'framer-motion'


/* ================= MAIN BACKGROUND ================= */

const MainContainer = styled(motion.div)`
  background-image: url(${img});
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: center;
`


/* ================= OVERLAY CONTAINER ================= */

const Container = styled.div`
  background-color: ${props => `rgba(${props.theme.bodyRgba}, 0.85)`};
  width: 100%;
  min-height: 100vh;

  position: relative;
  padding-bottom: 6rem;
  overflow-x: hidden;
`


/* ================= CENTER SECTION ================= */

const Center = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  padding: 8rem 0 4rem 0;

  @media (max-width: 1024px) {
    padding: 7rem 0 3rem 0;
  }

  @media (max-width: 768px) {
    padding: 7rem 0 3rem 0;
  }
`


/* ================= RESPONSIVE GRID ================= */

const Grid = styled.div`
  width: 85%;
  max-width: 1100px;
  margin: 0 auto;

  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 4rem;

  justify-content: center;
  align-items: start;

  /* ===== 1024px & BELOW ===== */
  @media (max-width: 768px) {
    width: 80%;
    grid-template-columns: 1fr;
    justify-items: center;
    gap: 3rem;
  }

  /* ===== Mobile ===== */
  @media (max-width: 768px) {
    width: 100%;
    grid-template-columns: 1fr;
    justify-items: center;
    gap: 2rem;
  }

/* ===== 376px – 425px ONLY ===== */
@media (min-width: 376px) and (max-width: 430px) {
  width: 100%;
  grid-template-columns: minmax(0, 290px);
  justify-content: center;
}

/* ===== 376px – 425px ONLY ===== */
@media (min-width: 376px) and (max-width: 430px) {
  justify-items: center;
}

/* ===== iPad Layout Tuning ===== */
@media (min-width: 769px) and (max-width: 1024px) {
  width: 88%;
  gap: 2rem;
}
`;




/* ================= FRAMER MOTION ================= */

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.4,
      duration: 0.5,
    }
  }
}


/* ================= COMPONENT ================= */

const BlogPage = () => {

  const [numbers, setNumbers] = useState(0);

  useEffect(() => {
    let num = (window.innerHeight - 70) / 30;
    setNumbers(parseInt(num));
  }, [])


  return (
    <MainContainer
      variants={container}
      initial="hidden"
      animate="show"
      exit={{ opacity: 0, transition: { duration: 0.5 } }}
    >
      <Container>

        <LogoComponent />
        <PowerButton />
        <SocialIcons />
        <AnchorComponent number={numbers} />

        <Center>
          <Grid>
            {Blogs.map(blog => (
              <BlogComponent key={blog.id} blog={blog} />
            ))}
          </Grid>
        </Center>

        {/* Darker background word */}
        <BigTitle text="FEATURES" top="4rem" left="6rem" />

      </Container>
    </MainContainer>
  )
}

export default BlogPage
